import { $ } from '../core/dom.js';
const LAYAR = ['loading', 'login', 'home', 'setup', 'quiz', 'result', 'belajar', 'modul', 'prestasi', 'peta'];
export function show(id) { LAYAR.forEach(s => { $('#scr-' + s).hidden = s !== id; }); }
